export default __webpack_public_path__ + "images/651d9be0790125f180747129f1479da3-country_music.webp";